import { render, staticRenderFns } from "./PresentationViewer.vue?vue&type=template&id=2c5bf9fa&scoped=true&"
import script from "./PresentationViewer.vue?vue&type=script&lang=js&"
export * from "./PresentationViewer.vue?vue&type=script&lang=js&"
import style0 from "./PresentationViewer.vue?vue&type=style&index=0&id=2c5bf9fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5bf9fa",
  null
  
)

export default component.exports